/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'box': {
    width: 26,
    height: 27,
    viewBox: '0 0 26 27',
    data: '<path pid="0" _fill="#EF7D01" fill-rule="evenodd" d="M21.06 8.427L9.392 2.647 12.952.954l11.64 5.634-3.533 1.84zm-7.703 4.87l4.461-2.265v3.479c0 .14.074.272.194.345.118.072.268.08.397.014l2.836-1.49a.403.403 0 00.221-.36V9.128l3.63-1.89v12.039l-11.739 6.06v-12.04zm-.404-.702L1.31 6.584 5.23 4.633l12.077 5.751-4.353 2.211zm7.704.178l-2.03 1.073v-3.474a.417.417 0 00-.23-.365L6.168 4.184l2.3-1.095L20.522 9.06l.134.068v3.644zm-8.11.524v12.04L.81 19.277V7.237l11.739 6.06zm.58-13.158a.41.41 0 00-.35 0L.232 6.21A.408.408 0 000 6.572v12.952c0 .153.085.292.22.36L12.77 26.36a.408.408 0 00.286.03.564.564 0 00.082-.03l12.547-6.474a.402.402 0 00.221-.36V6.574a.409.409 0 00-.23-.365L13.128.14z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/box.js